import api from "./api"; // seu serviço já com token e headers
import { IBookingnew } from "../types/bookingnew";

// Criar booking
export async function createBooking(data: Partial<IBookingnew>) {
  const response = await api.post("/bookingnew", data);
  return response.data;
}

export async function getBookingById(id: string): Promise<IBookingnew> {
const { data } = await api.get(`/bookingnew/${id}`); // GET /bookingnew/:id
return data;
}


export async function updateBooking(id: string, payload: Partial<IBookingnew>): Promise<IBookingnew> {
const { data } = await api.put(`/bookingnew/${id}`, payload); // PUT /bookingnew/:id
return data;
}


export async function confirmBooking(id: string): Promise<IBookingnew> {
const { data } = await api.post(`bookingnew/${id}/confirm`); // POST bookingnew/:id/confirm
return data;
}



export async function unconfirmBooking(id: string) {
  const response = await api.post(`/bookingnew/${id}/unconfirm`);
  return response.data;
}


// Listar bookings do usuário autenticado
export async function getMyBookings() {
  const response = await api.get("/bookingnew/me");
  return response.data;
}

// Listar todos os bookings (admin)
export async function getAllBookings() {
  const response = await api.get("/bookingnew");
  return response.data;
}
